import React, { useEffect, useState } from 'react';

import { Button, Box, TextField } from '@mui/material';


import { useDispatch, useSelector } from 'react-redux';
import { setQrCodeString } from '../../redux/stranice/odabir_vrste_qr';




export const GoogleRecenzijaForm = (props:any) => {

  const dispatch = useDispatch();
  const [googleId, setGoogleId] = useState('');
  const handleChangeGoogleId = (event:any) => {setGoogleId(event.target.value);};

  const generisi = () => { 

    if(googleId == ''){
      alert('Google ID je obavezan podatak. Mozete ga pronaci na sledecem linku: https://developers.google.com/maps/documentation/javascript/examples/places-placeid-finder ChIJhVHU8bV3WkcRoSqeww92yJk');
    }else{
       
      const webConfigURI = `https://search.google.com/local/writereview?placeid=${googleId}`;
        
      dispatch(setQrCodeString(webConfigURI)); 

    }
      
  }


  return(
    <>
            

            <Box 
              style={{padding:"20px"}} 
              maxWidth="xl"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                margin:'auto'
              }}
            >

            <TextField
                size="small"
                fullWidth
                onChange={handleChangeGoogleId}
                label="Google ID"
                variant="outlined"
                value={googleId}
            />

            <br/>
            <Button  color="success" variant="contained"  onClick={() => generisi()}>Generiši za Google recenziju</Button>


            
            </Box>


    
  </>
  
  )
}



export default GoogleRecenzijaForm;